import { render, staticRenderFns } from "./EventSetupMenu.vue?vue&type=template&id=54a03756"
import script from "./EventSetupMenu.vue?vue&type=script&lang=js"
export * from "./EventSetupMenu.vue?vue&type=script&lang=js"
import style0 from "./EventSetupMenu.vue?vue&type=style&index=0&id=54a03756&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports